import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const WorldSignal = () => (
  <section className="py-24 bg-brand-surface border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_right,_var(--tw-gradient-stops))] from-blue-900/15 via-transparent to-transparent"></div>
    <div className="max-w-4xl mx-auto px-6 lg:px-8 relative z-10">
      <SectionHeading title="The Signal" subtitle="2514 · The Threshold" />
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="space-y-6"
      >
        <p className="text-gray-300 leading-relaxed text-lg text-center">
          In <span className="text-brand-accent font-semibold">2514</span>, eleven days after the Odyssey crossed the heliopause, Neptune's Heliopause Observatory detected something that should not have existed: a signal from deep interstellar space.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 my-8">
          {[
            { label: 'Recursive', desc: 'Self-referencing structure' },
            { label: 'Deliberate', desc: 'Information density of a mind' },
            { label: 'Ancient', desc: 'Possibly millions of years old' },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-brand-dark border border-blue-500/20 rounded-xl p-5 text-center"
            >
              <p className="text-blue-400 font-display font-bold text-lg mb-1">{item.label}</p>
              <p className="text-gray-500 text-sm">{item.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="bg-brand-dark border border-blue-500/20 rounded-2xl p-8">
          <p className="text-gray-300 italic leading-relaxed text-lg text-center">
            "The chronicle ends here — deliberately. The next chapter is ours to write."
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WorldSignal;